// datepicker-i18n.service.ts
import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class DatepickerI18nService extends NgbDatepickerI18n {


  private weekdaysEn = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  // private weekdaysAr = ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'];
   private weekdaysAr = ['اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت', 'أحد'];

  private monthsEn = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  private monthsAr = [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ];
  isArabic: boolean;

  constructor(@Inject(LOCALE_ID) private locale: string, private translateService: TranslateService) {
    super();
    this.isArabic = this.translateService.getDefaultLang() == 'en' ? false : true;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      if (res) {
        this.isArabic = res.lang == 'en' ? false : true;
      }
    });
  }

  override getWeekdayLabel(weekday: number, width?: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined>): string {
    //throw new Error('Method not implemented.');
    //return 'dd';

    return this.isArabic ? this.weekdaysAr[weekday - 1] : this.weekdaysEn[weekday - 1];

  }
  getWeekdayShortName(weekday: number): string {
    return this.isArabic ? this.weekdaysAr[weekday - 1] : this.weekdaysEn[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return this.isArabic ? this.monthsAr[month - 1] : this.monthsEn[month - 1];
  }

  getMonthFullName(month: number): string {
    return this.isArabic ? this.monthsAr[month - 1] : this.monthsEn[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
